import React, { useState } from 'react';
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';
import { toast } from 'react-toastify';
import BtnFilled from '../../../components/BtnFilled';
import { GIS_STATUS_CLASS_NAME, GIS_STATUS_LABELS, GIS_ZHKH_PRICE_LABEL, GIS_ZHKH_SERIAL_HINT } from './constants';
import GisZhkkhNotice from './GisZhkkhNotice';
import { subscribeGisZhkkh } from './subscribeGisZhkkh';

/**
 * GIS-only status badge and renew payment button.
 * Must not be rendered for other integration keys.
 */
const GisZhkkhIntegrationActions = ({ integration, deviceId }) => {
  const [paying, setPaying] = useState(false);
  const status = integration?.status;
  const statusLabel = GIS_STATUS_LABELS[status];
  const showPayButton = status === 'waiting_payment';

  const handlePay = async () => {
    if (paying) return;
    setPaying(true);
    try {
      await subscribeGisZhkkh({
        deviceId,
        config: integration?.config || integration?.cfg || {},
        redirect: true,
      });
    } catch (err) {
      toast.error(err?.message || 'Не удалось создать платёж', { hideProgressBar: true });
      setPaying(false);
    }
  };

  return (
    <div className="mt-1 mb-1 space-y-2">
      <GisZhkkhNotice icon={<WarningAmberRoundedIcon className="mt-0.5 shrink-0 text-orange-500" fontSize="small" />}>
        {GIS_ZHKH_SERIAL_HINT}
      </GisZhkkhNotice>
      <div className="flex flex-wrap items-center gap-2">
        <span className="text-xs text-gray-500">{GIS_ZHKH_PRICE_LABEL}</span>
        {statusLabel && (
          <span className={`rounded-full px-2 py-0.5 text-xs font-medium ${GIS_STATUS_CLASS_NAME[status] || 'bg-gray-100 text-gray-600'}`}>
            {statusLabel}
          </span>
        )}
      </div>
      {showPayButton && (
        <BtnFilled className="w-auto px-4 py-1.5 text-sm" title={paying ? 'Оформление…' : 'Оплатить'} btnCb={handlePay} disabled={paying} />
      )}
    </div>
  );
};

export default GisZhkkhIntegrationActions;
